import { submitCredentialing } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { SubmitCredentialingRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';
import type { SubmitCredentialing200 } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function submitCredentialingApi(
  data: SubmitCredentialingRequestT,
  signal?: AbortSignal
): Promise<SubmitCredentialing200> {
  const config = await createLotusRequestConfig({ signal });
  const response = await submitCredentialing(data, config);
  return response.data;
}
